import classnames from 'classnames';

import { Text } from 'ui-components/components/text';
import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';

import FormattedCurrency from '../../../../../../components/formatted-currency/container';
import { useReturnDataContext } from '../../../return-data-provider';

import style from './styles.module.less';

type CostInfoProps = {
  label: React.ReactNode;
  amount: number;
  discardedAmount?: number;
  currency?: string;
  labelClassName?: string;
  priceClassName?: string;
  children?: React.ReactNode;
};

export function CostInfo({ label = '', amount = 0, discardedAmount, currency, labelClassName, priceClassName, children }: CostInfoProps) {
  const { requestDetails } = useReturnDataContext();

  const fallbackCurrency = requestDetails?.paymentInfo?.currency ?? '';
  const showDiscardedAmount = typeof discardedAmount === 'number' && !!discardedAmount && discardedAmount !== amount;

  return (
    <FlexColumn gap={Gap.Space8}>
      <FlexRow gap={Gap.Space16}>
        <FlexRow className={classnames(style.label, labelClassName)} gap={Gap.Space16}>
          {label}
        </FlexRow>
        <FlexRow className={style['price-row']} gap={Gap.Space12}>
          {showDiscardedAmount && (
            <Text
              className={style['discarded-price']}
              textType='Paragraph'
              value={<FormattedCurrency currencyCode={currency || fallbackCurrency} value={discardedAmount} />}
            />
          )}
          <Text
            className={classnames(style.price, priceClassName)}
            textType='Description'
            value={<FormattedCurrency currencyCode={currency || fallbackCurrency} value={amount} />}
          />
        </FlexRow>
      </FlexRow>
      {children}
    </FlexColumn>
  );
}
